export default "__VITE_ASSET__ad248f42__"